(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("draft-js"), require("immutable"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["draft-js", "immutable", "react"], factory);
	else if(typeof exports === 'object')
		exports["nextjsDraftWysiwyg"] = factory(require("draft-js"), require("immutable"), require("react"));
	else
		root["nextjsDraftWysiwyg"] = factory(root["draft-js"], root["immutable"], root["react"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__661__, __WEBPACK_EXTERNAL_MODULE__144__, __WEBPACK_EXTERNAL_MODULE__155__) => {
return 